export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-base_EN.ead879a1.png";